<template>
  <div class="inline-block pr-4 pb-4 w-full">
    <h4>
      {{ label }}
    </h4>
  </div>
</template>

<script>
export default {
  name: "DoeCellHeading",
  props: {
    label: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
h4 {
  @apply block font-sans font-semibold leading-normal max-w-4xl subpixel-antialiased text-xl text-blue-900 w-full;
}
h4.light {
  @apply font-light;
}
@screen lg {
  h4 {
    @apply leading-snug text-xl;
  }
}
</style>
